"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverPrimaryContent = exports.SeePriceInCart = void 0;
const react_1 = __importDefault(require("react"));
const canvas_box_1 = require("../canvas-box");
const responsive_popover_and_bottomsheet_toggler_1 = require("../responsive-popover-and-bottomsheet-toggler");
const themed_text_1 = require("../themed-text");
const SeePriceInCart = (props) => {
    const { withPopover = true } = props;
    if (!props.seePriceInCartCopy) {
        return null;
    }
    return withPopover ? (react_1.default.createElement(responsive_popover_and_bottomsheet_toggler_1.ResponsivePopoverAndBottomSheetToggler, { dataCy: "see-price-in-cart", primaryContent: react_1.default.createElement(exports.PopoverPrimaryContent, Object.assign({}, props)), headerText: props.title, innerContent: react_1.default.createElement(InnerPopoverContent, Object.assign({}, props)) })) : (react_1.default.createElement(themed_text_1.ThemedSpan, null, props.seePriceInCartCopy));
};
exports.SeePriceInCart = SeePriceInCart;
const PopoverPrimaryContent = ({ seePriceInCartCopy }) => (react_1.default.createElement(canvas_box_1.CanvasContainer, { margin: '3px 0px' },
    react_1.default.createElement(themed_text_1.ThemedAnchor, null, seePriceInCartCopy)));
exports.PopoverPrimaryContent = PopoverPrimaryContent;
const InnerPopoverContent = ({ description }) => (react_1.default.createElement(themed_text_1.ThemedParagraph, null, description));
__exportStar(require("./types"), exports);
